import React from "react"

import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const";
import FieldRating from "../rating"

type FieldQuickFilterViewProps = {
    field       : FieldRating;
    value       : any;
};

export default function FieldRating_QuickFilterView(props: FieldQuickFilterViewProps) {


    switch (props.value) {
        case BREAKDOWN_ALL_VALUES:
            return <div className="name">All ratings</div>

        default:
            const stars = new Array(props.field.scale).fill(true).fill(false, props.value);

            return (
                <div className="ui5-selector-rating">
                    {_.map(stars, (value, key)=>{
                        const classes = Classes("icon", {
                            'filled i5-star': value,
                            'empty i5-star-empty': !value,
                        });
                        return <div key={key} className={classes}/>
                    })}
                </div>
            )
    }

}